import {Model as BaseModel} from 'vue-api-query'

export default class Model extends BaseModel {

    // Define a base url for a REST API
    baseURL() {
        return '/api'
    }

    // Implement a default request method
    request(config) {
        if (config.url && config.url.includes('standard-agreement-noodzly-noodzler')) {
            config.hideLoader = true;
        }
        return this.$http.request(config)
    }
}
